import { defineComponent as _defineComponent } from 'vue'
import { Client } from 'ah-api-gateways/models';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { computed, watch } from 'vue';
import { useAhTradesState } from '../..';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';


export default /*#__PURE__*/_defineComponent({
  __name: 'CollateralInfoBlock',
  setup(__props) {

const onBehalfOfClient = useOnBehalfOf();

const tradeState = useAhTradesState();

tradeState.store.useWalletsStore().loadCollaterals({ force: false, clientId: onBehalfOfClient.value?.id });

const collaterals = computed(() => {
  const clientId = onBehalfOfClient.value
    ? onBehalfOfClient.value.id
    : tradeState.store.useAuthStore().loggedInIdentity?.client?.id;

  if (clientId) {
    return tradeState.store.useWalletsStore().getCollaterals(clientId);
  }

  return undefined;
});

watch(onBehalfOfClient, (current: Client | null, previous: Client | null) => {
  if (current && current.id !== previous?.id) {
    tradeState.store.useWalletsStore().loadCollaterals({ force: false, clientId: onBehalfOfClient.value?.id });
  }
});

return { __sfc: true,onBehalfOfClient, tradeState, collaterals, formatCurrencyValue }
}

})